import PropTypes from 'prop-types'
import React, { useState, useImperativeHandle, useEffect, useRef } from 'react'
import { Colors } from 'Theme'
import styles from './IFCheckPicker.module.css'
import { IFText, IFsvg } from 'Components'
import { CheckPicker } from 'rsuite'
import { getTextWidth } from '../../../Utils/Calculations'

const IFCheckPicker = React.forwardRef(
  (
    {
      title,
      data,
      onValueChange = () => {},
      initialValue,
      isChargingSpeed = false,
      labels,
    },
    ref,
  ) => {
    const [isOpen, setIsOpen] = useState(false)
    const [value, setValue] = useState(initialValue)
    const clearValue = () => {
      setValue([])
    }

    useImperativeHandle(ref, () => ({
      clearValue,
      isOpen,
    }))
    const options = []
    for (const index in data) {
      isChargingSpeed
        ? options.push({ label: data[index].label, value: data[index].value })
        : options.push({
            // `labels` lets a filter show a friendly name while `value` stays
            // the wire token (e.g. chargingState SuspendedEV -> Suspended (EV))
            label: labels?.[data[index]] ?? data[index],
            value: data[index],
          })
    }
    useEffect(() => {
      setValue(initialValue)
    }, [initialValue])
    const pickerRef = useRef()

    return (
      <div ref={pickerRef} className={styles.wrapperContainer}>
        <div className={styles.container}>
          <CheckPicker
            style={{
              width: getTextWidth(title, `600 ${14}px ProximaNova`) + 16,
            }}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            value={value}
            onSelect={(value) => {
              onValueChange(value)
              setValue(value)
            }}
            container={() => pickerRef?.current}
            data={options}
            cleanable={false}
            size="lg"
            searchable={false}
            placeholder={title}
            renderValue={() => (
              <div>
                <IFText>{title}</IFText>
              </div>
            )}
            className={styles.CheckPicker}
          />
          <div className={styles.TextWrapper}>
            <IFText className={styles.Text}>
              {/* {Replacing all spaces with &nbsp; for styling} */}
              {title.replaceAll(' ', '\u00a0')}
            </IFText>
            <div>
              <IFsvg.Expand
                height={20}
                width={20}
                fill={Colors.FilterIconFilled}
              />
            </div>
          </div>
        </div>
      </div>
    )
  },
)

IFCheckPicker.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  onValueChange: PropTypes.func.isRequired,
  initialValue: PropTypes.array,
  isChargingSpeed: PropTypes.bool,
  labels: PropTypes.object,
}

export default IFCheckPicker
